import { actionTypes } from "../actions/actions";

const initailData = {
  loginData: null,
  selectedSite: null,
  selectedCompany: null,
  selectedProject: null,
  chooseSite: null,
  alertData: {
    showAlert: false,
    title: "",
    text: "",
    text2: ""
  },
  reportData: {
    showReport: false,
    name: "",
    recordId: 0
  },
  reportSuccess: false,
  selectedClientData: {},
  showAddproject: false,
  showExportModal: false,
  showAddexperience: false,
  projectImages: [],
  showMapmodal: {
    open: false,
    from: "",
    select: ""
  },
  selectedMontage: null,
  builderBucksCount: 0,
  updateSiteprojects: false,
  selectLocation: {
    open: false,
    lat: 0,
    lng: 0
  },
  menuCardBuilderBucks: {
    sites: 0,
    years: 0,
    companies: 0,
    bucks: 0
  },
  noLocationcount: 0,
  miannotification: 0,
  noLocationSites: [],
  showAddpost: false,
  chatState: null,
  chatSeletedState: null,
  multiLanguageData: {},
  selectedLanguage: "en",
  previousQuestionId: 0,
  selectedSiteId: 0,
  unreadMsgCount: 0,
  clientChatCount: 0,
  dashboardData: null,
  from: "",
  surveyLaterToday: "false",
  clientLicenses: [
    {
      appName: "BuildID",
      route: "/dashboard"
    }
  ],
  getClientData: false,
  clientPictureBoard: {},
  noLicenseAccess: false,
  carpoolOptLoader: {
    isLoading: false,
    optedFlag: ""
  },
  chatGroups: [],
  selectedChat: {},
  carpoolOnlyShowPeople: false,
  open: false,
  selectedUsers: [],
  jobSelectedLocation: {
    address: "",
    lat: null,
    lng: null,
    range: 80
  },
  showOrganizationModal: false,
  communityPostIds: { all: [], products: [], projects: [], trades: [] },
  lastSyncCommunityTime: null,
  openNotificationMenu: false,
  selectedAppPermissions: []
};

const mainReducer = (state = initailData, action) => {
  switch (action.type) {
    case actionTypes.SET_LOGIN_DATA:
      return {
        ...state,
        loginData: action?.payload
      };

    case actionTypes.SET_LOCATION_FOR_GLOBAL_SEARCH:
      return {
        ...state,
        globalSearchLocation: action?.payload
      };
    case actionTypes.SET_SELECTED_SITE:
      return {
        ...state,
        selectedSite: action?.payload
      };
    case actionTypes.SET_CHOOSE_SITE:
      return {
        ...state,
        chooseSite: action?.payload
      };
    case actionTypes.SET_SELECTED_COMPANY:
      return {
        ...state,
        selectedCompany: action?.payload
      };
    case actionTypes.SET_SHOW_ALERT:
      return {
        ...state,
        alertData: action?.payload
      };
    case actionTypes.SET_SHOW_REPORT:
      return {
        ...state,
        reportData: action?.payload
      };
    case actionTypes.SET_SELECTED_CLIENT_DATA:
      return {
        ...state,
        selectedClientData: action?.payload
      };
    case actionTypes.SET_SHOW_ADD_PROJECT:
      return {
        ...state,
        showAddproject: action?.payload
      };
    case actionTypes.SET_SHOW_EXPORT_MODEL:
      return {
        ...state,
        showExportModal: action?.payload
      };
    case actionTypes.SET_SHOW_ADD_EXPERIENCE:
      return {
        ...state,
        showAddexperience: action?.payload
      };
    case actionTypes?.SET_SELECTED_PROJECT_DATA:
      return {
        ...state,
        selectedProject: action?.payload
      };
    case actionTypes.SET_MENU_CARD_BUILDER_BUCKS:
      return {
        ...state,
        menuCardBuilderBucks: action?.payload
      };
    case actionTypes?.SET_PROJECT_IMAGES:
      return {
        ...state,
        projectImages: action?.payload
      };

    case actionTypes?.SET_SHOW_MAP_MODAL:
      return {
        ...state,
        showMapmodal: action?.payload
      };
    case actionTypes.SET_BUILDER_BUCKS_COUNT:
      return {
        ...state,
        builderBucksCount: action?.payload
      };
    case actionTypes.SET_CHAT_COUNT:
      return {
        ...state,
        unreadMsgCount: action?.payload
      };
    case actionTypes.SET_CLIENT_CHAT_COUNT:
      return {
        ...state,
        clientChatCount: action?.payload
      };
    case actionTypes.SET_PROJECT_LIST_UPDATE:
      return {
        ...state,
        updateSiteprojects: action?.payload
      };
    case actionTypes.SET_SELECT_LOCATION:
      return {
        ...state,
        selectLocation: action?.payload
      };
    case actionTypes.SET_NO_LOCATION_COUNT:
      return {
        ...state,
        noLocationcount: action?.payload
      };
    case actionTypes.SET_MAIN_NOTIFICATION:
      return {
        ...state,
        miannotification: action?.payload
      };
    case actionTypes.SET_NO_LOCATION_SITES:
      return {
        ...state,
        noLocationSites: action?.payload
      };
    case actionTypes.SET_PREVIOUS_QUESTION_ID:
      return {
        ...state,
        previousQuestionId: action?.payload
      };
    case actionTypes.SET_SELECTED_SITE_ID:
      return {
        ...state,
        selectedSiteId: action?.payload
      };

    case actionTypes.SET_LOGOUT:
      return {
        ...initailData
      };
    case actionTypes.SET_SELECTED_MONTAGE:
      return {
        ...state,
        selectedMontage: action?.payload
      };
    case actionTypes.SET_SHOW_ADDPOST:
      return {
        ...state,
        showAddpost: action?.payload
      };
    case actionTypes.SET_CHAT_STATE:
      return {
        ...state,
        chatState: action.payload
      };
    case actionTypes.RESET_CHAT_STATE:
      return {
        ...state,
        chatState: null
      };
    case actionTypes.SET_SELETED_CHAT_STATE:
      return {
        ...state,
        chatSeletedState: action.payload
      };
    case actionTypes.SET_DASHBOARD_DATA:
      return {
        ...state,
        dashboardData: action.payload
      };
    case actionTypes.RESET_SELETED_CHAT_STATE:
      return {
        ...state,
        chatSeletedState: null
      };
    case actionTypes.SET_MULTILANGUAGE_DATA:
      return {
        ...state,
        multiLanguageData: action.payload
      };
    case actionTypes.SET_MULTILANGUAGE_CODE:
      return {
        ...state,
        selectedLanguage: action.payload
      };
    case actionTypes.SET_FROM:
      return {
        ...state,
        from: action.payload
      };
    case actionTypes.SET_SURVEY_LATER_TODAY:
      return {
        ...state,
        surveyLaterToday: action?.payload
      };
    case actionTypes.SET_LICENSES:
      return {
        ...state,
        clientLicenses: action.payload
      };
    case actionTypes.SET_NO_LICENSE_ACCESS:
      return {
        ...state,
        noLicenseAccess: action.payload
      };
    case actionTypes.SET_REPORT_SUCCESS:
      return {
        ...state,
        reportSuccess: action?.payload
      };
    case actionTypes.SET_GET_CLIENT_DATA:
      return {
        ...state,
        getClientData: action?.payload
      };
    case actionTypes.SET_PICTURE_BOARD_DATA:
      return {
        ...state,
        clientPictureBoard: action?.payload
      };
    case actionTypes.SET_IS_CARPOOL_OPT_OUT:
      return {
        ...state,
        carpoolOptLoader: action?.payload
      };
    case actionTypes.SET_CARPOOL_SWITCH_VALUE:
      return {
        ...state,
        carpoolOnlyShowPeople: action?.payload
      };
    case actionTypes.SET_OPEN:
      return {
        ...state,
        open: action?.payload
      };
    case actionTypes?.SET_SELECTED_USERS:
      return {
        ...state,
        selectedUsers: action?.payload
      };
    case actionTypes?.SET_JOB_SELECTED_LOCATION:
      return {
        ...state,
        jobSelectedLocation: action?.payload
      };
    case actionTypes.SET_SHOW_ORGANIZATION_MODAL:
      return {
        ...state,
        showOrganizationModal: action?.payload
      };
    case actionTypes.SET_CHAT_GROUPS:
      return {
        ...state,
        chatGroups: action?.payload
      };
    case actionTypes.SET_SELECTED_CHAT:
      return {
        ...state,
        selectedChat: action?.payload
      };
    case actionTypes.SET_COMMUNITY_POST_IDS:
      return {
        ...state,
        communityPostIds: action?.payload
      };
    case actionTypes.ADD_COMMUNITY_POST_IDS:
      return {
        ...state,
        communityPostIds: [...state.communityPostIds, ...action?.payload]
      };
    case actionTypes.CLEAR_COMMUNITY_POST_IDS:
      return {
        ...state,
        communityPostIds: { all: [], products: [], projects: [], trades: [] }
      };
    case actionTypes.SET_LAST_SYNC_COMMUNITY_TIME:
      return {
        ...state,
        lastSyncCommunityTime: action?.payload
      };
    case actionTypes.SET_OPEN_NOTIFICATION_MENU:
      return {
        ...state,
        openNotificationMenu: action?.payload
      };
    case actionTypes.SET_SELECTED_APP_PERMISSIONS:
      return {
        ...state,
        selectedAppPermissions: action?.payload
      };
    default:
      return state;
  }
};

export default mainReducer;
